<template src="./register.html">

</template>

<script>
import { save_newAccount } from "@/api/api.account.js";
import mixin from "@/mixin/styleMixin.js";

export default {
  mixins: [mixin],

  data: () => ({
    e1: true,
    cred: {
      Utente: "",
      Password: "",
      RagSociale: "",
      Piva: "",
      EMail: "",
      ConfermaPassword: ""
    },
    disabilitaBtn: false,
    alertElaborazione: "",
    tipo: "success",
    OK: false,
    checkPrivacy: false,

    style: {
      maxWidth: "300px",
      maxHeight: "570px",
      marginLeft: "auto",
      marginRight: "auto"
    }
  }),

  methods: {
    registra() {
      // Validazione
      if (this.$refs.formRegistra.validate() == false) {
        return;
      }

      // Reset
      this.alertElaborazione = "";
      this.disabilitaBtn = true;

      // Registro
      save_newAccount(this.cred)
        .then(res => {
          this.tipo = "success";
          this.alertElaborazione =
            "Registrazione avvenuta, riceverai entro 12 ore una mail con il link per attivare il tuo account. Nel caso non la ricevessi, contatta i nostri uffici.";

          this.disabilitaBtn = false;

          this.OK = true;
        })
        .catch(err => {
          console.log("register.vue " + err);

          this.disabilitaBtn = false;
          this.tipo = "warning";
          this.alertElaborazione = err.response.data.Message;
        });
    }
  }
};
</script>


